import React from 'react';
import { Link } from 'react-router-dom';
import './Services.css';

const services = [
  {
    number: '01',
    title: 'Residential Construction',
    slug: 'residential-construction',
    description: 'Expert home building and renovations across London. From Victorian restorations to sleek modern new builds, we bring your vision to life.',
    image: '/images/services/skylight-rooftop.jpeg',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
        <polyline points="9,22 9,12 15,12 15,22"/>
      </svg>
    )
  },
  {
    number: '02',
    title: 'Commercial Projects',
    slug: 'commercial-projects',
    description: 'Office buildings, retail spaces, and mixed-use developments delivered on time and within budget. We understand business needs.',
    image: '/images/services/interior-finishing.jpeg',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="4" y="2" width="16" height="20" rx="2"/>
        <line x1="8" y1="6" x2="16" y2="6"/>
        <line x1="8" y1="10" x2="16" y2="10"/>
        <line x1="8" y1="14" x2="12" y2="14"/>
      </svg>
    )
  },
  {
    number: '03',
    title: 'Window & Door Installation',
    slug: 'window-door-installation',
    description: 'Premium aluminum and wooden windows and doors. Expert installation with modern designs and excellent insulation.',
    image: '/images/services/window-installation.jpeg',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="3" y="3" width="18" height="18" rx="2"/>
        <line x1="12" y1="3" x2="12" y2="21"/>
        <line x1="3" y1="12" x2="21" y2="12"/>
      </svg>
    )
  },
  {
    number: '04',
    title: 'Bathroom & Kitchen Fitting',
    slug: 'bathroom-kitchen-fitting',
    description: 'Complete bathroom and kitchen renovations with modern fixtures, glass shower enclosures, and premium finishes.',
    image: '/images/services/bathroom-fitting.jpeg',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"/>
        <rect x="9" y="3" width="6" height="4" rx="1"/>
        <path d="M9 12l2 2 4-4"/>
      </svg>
    )
  },
  {
    number: '05',
    title: 'Glass & Steel Railings',
    slug: 'glass-steel-railings',
    description: 'Elegant stainless steel and glass balustrades for stairs, balconies, and terraces. Modern safety meets sophisticated design.',
    image: '/images/services/glass-railings.jpeg',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <polygon points="12,2 22,8.5 22,15.5 12,22 2,15.5 2,8.5"/>
        <line x1="12" y1="22" x2="12" y2="15.5"/>
        <polyline points="22,8.5 12,15.5 2,8.5"/>
        <polyline points="2,15.5 12,8.5 22,15.5"/>
        <line x1="12" y1="2" x2="12" y2="8.5"/>
      </svg>
    )
  },
  {
    number: '06',
    title: 'Ceiling & Interior Finishing',
    slug: 'ceiling-interior-finishing',
    description: 'Professional suspended ceilings, partition walls, and interior finishing. Transform spaces with quality craftsmanship.',
    image: '/images/services/ceiling-work.jpeg',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="3" y="3" width="18" height="18" rx="2"/>
        <path d="M3 9h18"/>
        <path d="M9 21V9"/>
      </svg>
    )
  }
];

const Services = () => {
  return (
    <section className="services" id="services">
      <div className="services__container">
        <div className="services__header">
          <span className="section-label">What We Do</span>
          <h2 className="section-title">
            Comprehensive <span className="text-accent">Building Solutions</span>
          </h2>
          <p className="services__intro">
            From concept to completion, we deliver exceptional construction services 
            tailored to your unique requirements. Our expertise spans across all aspects 
            of building and development.
          </p>
        </div>
        
        <div className="services__grid">
          {services.map((service, index) => (
            <div 
              className="service-card" 
              key={index}
            >
              <div className="service-card__image">
                <img src={service.image} alt={service.title} loading="lazy" />
                <div className="service-card__image-overlay"></div>
              </div>
              <span className="service-card__number">{service.number}</span>
              <div className="service-card__icon">
                {service.icon}
              </div>
              <div className="service-card__content">
                <h3 className="service-card__title">{service.title}</h3>
                <p className="service-card__description">{service.description}</p>
                <Link to={`/services/${service.slug}`} className="service-card__link">
                  Learn More
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                  </svg>
                </Link>
              </div>
              <div className="service-card__hover-line"></div>
            </div>
          ))}
        </div>
      </div>
      
      {/* Background Decorations */}
      <div className="services__decoration services__decoration--1"></div>
      <div className="services__decoration services__decoration--2"></div>
    </section>
  );
};

export default Services;

